import React from "react";

function InterviewTally({ categories, formState, calculatePoints }) {
  return (
    <div className="mt-4 p-3">
      <label className="fw-bold">Points per Category</label>
      <div className="row mt-3">
        {categories.map(({ label, key }) => (
          <div
            key={key}
            className="mx-2 text-center"
            style={{ width: "125px" }}
          >
            <input
              type="text"
              value={formState[key]}
              className="form-control border-0 border-bottom rounded-0 text-center"
              readOnly
            />
            <label className="mt-2 text-muted">{label}</label>
          </div>
        ))}

        <div className="mx-2 text-center" style={{ width: "125px" }}>
          <input
            type="text"
            value={calculatePoints}
            className="form-control border-0 border-bottom rounded-0 text-center fw-bold"
            readOnly
          />
          <label className="mt-2 text-bold">Total Points</label>
        </div>
      </div>
    </div>
  );
}

export default InterviewTally;
